export const APP_NAME = "FinBoard";
export const APP_VERSION = "11.3";

// Encryption key — consistent for all users so everyone can read/write data
// In a real app this would come from a backend. For client-side, this is the best approach.
export const ENCRYPTION_KEY = "FB11_PBKDF2_AES256_GCM_2026";

// Admin PIN hashes (SHA-256) — plain PINs never stored
export const ADMIN_HASHES = [
  "89b933c62993dd19e05ae115f18c12491e28b67834079aff0a79c94e4472be1b",
  "882277663e03e23ed876fa788cbbafd6397bf41340d01f529e8d3c43ce3040bf",
];

export const MAX_LOGIN_ATTEMPTS = 5;
export const LOCKOUT_DURATION_MS = 5 * 60 * 1000;
export const SESSION_TIMEOUT_MS = 30 * 60 * 1000;
export const SESSION_CHECK_INTERVAL = 5000;
export const MAX_PENDING_LOANS = 3;
export const MAX_AMOUNT = 10_00_00_000;
export const MAX_AUDIT_ENTRIES = 500;
export const MAX_CODE_LENGTH = 20;
export const MAX_NAME_LENGTH = 50;
export const SALARY_LOAN_MULTIPLIER = 3;
export const API_COOLDOWN_MS = 60000;

export const CATEGORIES = [
  { name: "Server & Hosting", color: "#22D3EE" },
  { name: "Software & Tools", color: "#A78BFA" },
  { name: "Marketing", color: "#3B82F6" },
  { name: "Salaries", color: "#F5A623" },
  { name: "Office Rent", color: "#F97316" },
  { name: "Travel", color: "#EC4899" },
  { name: "Food & Entertainment", color: "#EAB308" },
  { name: "Crypto Gas Fees", color: "#6366F1" },
  { name: "Stake Operations", color: "#EF4444" },
  { name: "Domain & SSL", color: "#14B8A6" },
  { name: "Equipment", color: "#8B5CF6" },
  { name: "Legal & Compliance", color: "#78716C" },
  { name: "Insurance", color: "#0EA5E9" },
  { name: "Training & Education", color: "#D946EF" },
  { name: "Miscellaneous", color: "#64748B" },
];

export const COINS = [
  { id: "inr-fiat", symbol: "INR", name: "Indian Rupee", color: "#FF9933", icon: "🇮🇳", isFiat: true },
  { id: "bitcoin", symbol: "BTC", name: "Bitcoin", color: "#F7931A", icon: "₿" },
  { id: "ethereum", symbol: "ETH", name: "Ethereum", color: "#627EEA", icon: "Ξ" },
  { id: "litecoin", symbol: "LTC", name: "Litecoin", color: "#BFBBBB", icon: "Ł" },
  { id: "tether", symbol: "USDT", name: "Tether", color: "#26A17B", icon: "₮" },
  { id: "solana", symbol: "SOL", name: "Solana", color: "#14F195", icon: "◎" },
  { id: "dogecoin", symbol: "DOGE", name: "Dogecoin", color: "#C2A633", icon: "Ð" },
  { id: "bitcoin-cash", symbol: "BCH", name: "Bitcoin Cash", color: "#8DC351", icon: "Ƀ" },
  { id: "ripple", symbol: "XRP", name: "XRP", color: "#346AA9", icon: "✕" },
  { id: "tron", symbol: "TRX", name: "TRON", color: "#FF0013", icon: "T" },
  { id: "eos", symbol: "EOS", name: "EOS", color: "#443F54", icon: "E" },
  { id: "binancecoin", symbol: "BNB", name: "BNB", color: "#F3BA2F", icon: "B" },
  { id: "usd-coin", symbol: "USDC", name: "USD Coin", color: "#2775CA", icon: "$" },
  { id: "apecoin", symbol: "APE", name: "ApeCoin", color: "#0054F7", icon: "A" },
  { id: "binance-usd", symbol: "BUSD", name: "Binance USD", color: "#F0B90B", icon: "B" },
  { id: "crypto-com-chain", symbol: "CRO", name: "Cronos", color: "#002D74", icon: "C" },
  { id: "dai", symbol: "DAI", name: "Dai", color: "#F4B731", icon: "◈" },
  { id: "chainlink", symbol: "LINK", name: "Chainlink", color: "#2A5ADA", icon: "⬡" },
  { id: "the-sandbox", symbol: "SAND", name: "The Sandbox", color: "#00ADEF", icon: "S" },
  { id: "shiba-inu", symbol: "SHIB", name: "Shiba Inu", color: "#FFA409", icon: "S" },
  { id: "uniswap", symbol: "UNI", name: "Uniswap", color: "#FF007A", icon: "🦄" },
  { id: "matic-network", symbol: "POL", name: "Polygon", color: "#8247E5", icon: "P" },
  { id: "official-trump", symbol: "TRUMP", name: "TRUMP", color: "#C8102E", icon: "T" },
];

export const CURRENCIES = [
  { code: "inr", symbol: "\u20B9", name: "INR" },
  { code: "usd", symbol: "$", name: "USD" },
  { code: "eur", symbol: "\u20AC", name: "EUR" },
  { code: "gbp", symbol: "\u00A3", name: "GBP" },
  { code: "aed", symbol: "AED", name: "AED" },
];

export const PAYMENT_METHODS = [
  "Cash", "Bank Transfer", "UPI", "PayPal", "Razorpay",
  "Crypto (BTC)", "Crypto (ETH)", "Crypto (USDT)", "Crypto (LTC)",
  "Crypto (SOL)", "Crypto (DOGE)", "Crypto (BCH)", "Crypto (XRP)",
  "Crypto (TRX)", "Crypto (EOS)", "Crypto (BNB)", "Crypto (USDC)",
  "Crypto (APE)", "Crypto (BUSD)", "Crypto (CRO)", "Crypto (DAI)",
  "Crypto (LINK)", "Crypto (SAND)", "Crypto (SHIB)", "Crypto (UNI)",
  "Crypto (POL)", "Crypto (TRUMP)",
];

export const TEAM_ROLES = [
  "Full Stack Developer", "Frontend Developer", "Backend Developer",
  "Mobile App Developer", "DevOps Engineer", "QA Tester",
  "UI/UX Designer", "Graphic Designer", "Video Editor", "Motion Designer",
  "Content Writer", "Copywriter", "Blog Manager", "Script Writer",
  "SEO Specialist", "Ads Manager", "Social Media Manager",
  "Marketing Manager", "Email Marketing", "Influencer Manager",
  "VIP Manager", "Support Agent", "Customer Success",
  "Sales Executive", "Business Development", "Account Manager",
  "HR Manager", "Recruiter", "Office Manager",
  "Finance Manager", "Accountant", "Data Analyst", "Data Scientist",
  "Project Manager", "Product Manager", "Scrum Master",
  "Team Lead", "CTO", "COO", "CEO", "CFO",
  "Intern", "Freelancer", "Consultant", "Advisor",
  "Admin",
];

export const SALARY_CYCLES = ["Monthly", "Weekly", "Bi-Weekly", "Daily", "Per Project"];
